import React from 'react';

import {
    DOMAIN_BALDWIN,
    DOMAIN_TFS,
    Context
} from "../Constant";
import TFS_LOGO from './tfs-logo.png';
import PARKER_LOGO from './logo-black-hex.jpg';
import BALDWIN_LOGO from './baldwin-logo.jpg';

const Header = props => {
    const { domainName } = props.context;
    return (
        <header className="header" role="banner">
            <div className="phlogo">
                <a href="/">
                    <img
                        src={domainName === DOMAIN_TFS ? TFS_LOGO : domainName === DOMAIN_BALDWIN ? BALDWIN_LOGO : PARKER_LOGO}
                        alt="Logo" />
                </a>
            </div>
        </header>
    )
}

export default props => (
    <Context.Consumer>
        {state => <Header context={state} contextProps={props} />}
    </Context.Consumer>
);